import { Translation } from 'react-i18next';

/**
 * Components
 */
import ComponentCoding from '@/components/coding';
import ComponentNavigate from '@/components/navigate';

// Index
// import PageIndex from '@/pages/index';

// Attachment
import PageAttachments from '@/pages/attachment/attachments';

// Wallpaper

// System Management
import PageConfigs from '@/pages/system-management/configs';
import PageConfigsCreateEdit from '@/pages/system-management/configs/create_edit';
import PageRoles from '@/pages/system-management/roles';
import PageSystemLogs from '@/pages/system-management/system-logs';
import PageUsers from '@/pages/system-management/users';
import PageUsersDetail from '@/pages/system-management/users/detail';

/**
 * Types
 */
import type { Route } from '@ant-design/pro-layout/es/typing';
import type { RouteObject } from 'react-router-dom';

export default [
    {
        element: <ComponentCoding />,
        name: <Translation>{(t) => t('roles:Dashboard')}</Translation>,
        path: '/',
    },
    {
        children: [
            {
                element: <PageAttachments />,
                name: <Translation>{(t) => t('roles:Attachments_Attachments')}</Translation>,
                path: 'attachments',
            },
        ],
        element: <ComponentNavigate />,
        name: <Translation>{(t) => t('roles:Attachments')}</Translation>,
        path: 'attachment',
    },
    {
        children: [
            {
                element: <ComponentCoding />,
                name: <Translation>{(t) => t('roles:Wallpapers_Categories')}</Translation>,
                path: 'categories',
            },
            {
                element: <ComponentCoding />,
                name: <Translation>{(t) => t('roles:Wallpapers_Posts')}</Translation>,
                path: 'posts',
            },
        ],
        element: <ComponentNavigate />,
        name: <Translation>{(t) => t('roles:Wallpapers')}</Translation>,
        path: 'wallpaper',
    },
    {
        children: [
            {
                element: <PageUsers />,
                name: <Translation>{(t) => t('roles:System-Management_Users')}</Translation>,
                path: 'users',
            },
            {
                element: <PageUsersDetail />,
                hideInMenu: true,
                name: <Translation>{(t) => t('roles:System-Management_Users_Details')}</Translation>,
                parentKeys: ['users'],
                path: 'users/:id',
            },
            {
                element: <PageRoles />,
                name: <Translation>{(t) => t('roles:System-Management_Roles')}</Translation>,
                path: 'roles',
            },
            {
                element: <PageConfigs />,
                name: <Translation>{(t) => t('roles:System-Management_Configs')}</Translation>,
                path: 'configs',
            },
            {
                element: <PageConfigsCreateEdit />,
                hideInMenu: true,
                name: <Translation>{(t) => t('roles:System-Management_Configs_Create')}</Translation>,
                parentKeys: ['configs'],
                path: 'configs/create',
            },
            {
                element: <PageConfigsCreateEdit />,
                hideInMenu: true,
                name: <Translation>{(t) => t('roles:System-Management_Configs_Edit')}</Translation>,
                parentKeys: ['configs'],
                path: 'configs/:id/edit',
            },
            {
                element: <PageSystemLogs />,
                name: <Translation>{(t) => t('roles:System-Management_System-Logs')}</Translation>,
                path: 'system-logs',
            },
        ],
        element: <ComponentNavigate />,
        name: <Translation>{(t) => t('roles:System-Management')}</Translation>,
        path: 'system-management',
    },
] as (Route & RouteObject)[];
